/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');
require('../plugins');



if(document.getElementById("format")) {
    const card = document.getElementById("format");
    card.addEventListener("change", (event) =>{
        const selectedValue = event.target.value;
        document.getElementById('selected-result').value = selectedValue;
        document.getElementById('download-source').setAttribute('href',selectedValue);
    });

}

document.querySelectorAll(".copy-link").forEach((copyLinkParent) => {
    const inputField = copyLinkParent.querySelector(".copy-link-input");
    const copyButton = copyLinkParent.querySelector(".copy-link-button");

    // inputField.addEventListener("focus", () => inputField.select());

    copyButton.addEventListener("click", () => {
        inputField.select();
        const text = inputField.value;
        navigator.clipboard.writeText(text);

        inputField.value = "Copied!";
        setTimeout(() => (inputField.value = text), 2000);
    });
});

// Open Prolong
if(document.getElementById('prolongButton')){

let prolong = document.getElementById('prolongButton');
prolong.addEventListener('click', function() {
    let prolongContainer = document.getElementById('prolong-container');
    if (prolongContainer.style.display == 'none') {
        prolongContainer.style.display = 'flex';
    }else {
        prolongContainer.style.display = 'none';
    }
}, false);
}
